import { render, staticRenderFns } from "./AddRevision.vue?vue&type=template&id=4e55757c&scoped=true"
import script from "./AddRevision.vue?vue&type=script&lang=js"
export * from "./AddRevision.vue?vue&type=script&lang=js"
import style0 from "./AddRevision.vue?vue&type=style&index=0&id=4e55757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55757c",
  null
  
)

export default component.exports